import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { ServerErrorMessage } from '../../../../../../shared/utils/error';
import TiposCambioScreen from './screen';
import { TiposCambioAdapter, TipoCambio } from '../../../../../../infraestructure/persistence/rest/TiposCambioAdapter';
import { useNotifications} from '../../../../../../shared/hooks/Notifications';

export const TiposCambioContainer = () => {

	const api = new TiposCambioAdapter();
	const {resultError, exceptionError, launchNotification} = useNotifications();
	let [ tipos, setTipos ] = useState<any>([]);
	let result: any;

	// useEffect(() => {
	// 	getTiposCambio();
	// }, []);

	useEffect(() => {}, [ tipos ]);

	const getTiposCambio = async (año:number, mes:number) => {
		try {
			result = await api.ListarTiposCambio(año,mes);
			if(result.data && result.data!=="")
			{
				setTipos([ ...result.data ] || []);
			}else{resultError()}
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
		}
	};

	return (
		<>
			<TiposCambioScreen data={tipos} onFilter={getTiposCambio}/>
		</>
	);
};

export default TiposCambioContainer;
